import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function FolderIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon
      viewBox="0 0 20 20"
      {...props}
      style={{ fill: props.fill ?? Color.DetailsInput }}
    >
      <path d="M3.58975 16.25C3.1688 16.25 2.81249 16.1041 2.52083 15.8125C2.22916 15.5208 2.08333 15.1645 2.08333 14.7435V5.25642C2.08333 4.83547 2.22916 4.47917 2.52083 4.1875C2.81249 3.89583 3.1688 3.75 3.58975 3.75H7.54164C7.74249 3.75 7.93559 3.789 8.12095 3.867C8.30631 3.94499 8.46737 4.05235 8.60412 4.1891L9.83168 5.41667H16.4102C16.8311 5.41667 17.1875 5.5625 17.4791 5.85417C17.7708 6.14583 17.9166 6.50214 17.9166 6.92308V14.7435C17.9166 15.1645 17.7708 15.5208 17.4791 15.8125C17.1875 16.1041 16.8311 16.25 16.4102 16.25H3.58975Z" />
    </MuiSvgIcon>
  );
}
export default FolderIcon;
